const getLocalStorage = (key) => {
  const localData = localStorage.getItem(key);

  if (!localData) return null;

  return JSON.parse(localData);
};

const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

const LocalStorage = {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
};

export default LocalStorage;
